/* eslint-disable no-imports/outside-special-folder */
import React from 'react';
import { Helmet } from 'react-helmet-async';

import { useTranslation } from 'app/lang';
import { getUniversalUrl, URL_TYPE } from 'app/lib/get-universal-url';
import useCurrentRegion from 'app/lib/region/useCurrentRegion';
import { getBackendServerUrl } from 'app/ssr/utils';

import dictionary from './Seo.dictionary.json';

export const SeoChesnok = () => {
  const { t, lang } = useTranslation();
  const currentRegion = (useCurrentRegion() || 'uz').toLowerCase();

  return (
    <Helmet>
      <html lang={lang} />

      <title>{t(dictionary.titleChesnok)}</title>
      <meta name="description"
            content={t(dictionary.descriptionChesnok)} />

      <link rel="canonical"
            href={getBackendServerUrl()} />

      <meta
        name="keywords"
        content={t(dictionary.keywordsChesnok)} />
      <meta name="robots"
            content="index, follow" />
      {/* <!-- Open Graph protocol. for social networks: VK, FB, Одноклассники --> */}
      <meta property="og:type"
            content="website" />
      <meta property="og:site_name"
            content="chesnok bet" />
      <meta
        property="og:title"
        content={t(dictionary.ogTitleChesnok)} />
      <meta property="og:url"
            content={`https://${currentRegion}.chesnok.bet/`} />
      <meta property="og:locale"
            content={`ru_${currentRegion.toUpperCase()}`} />
      <meta property="og:image"
            content={getUniversalUrl('images/favicon.svg', URL_TYPE.PUBLIC)} />
      <meta
        property="og:description"
        content={t(dictionary.descriptionChesnok)} />

      <link href="https://uz.chesnok.bet"
            rel="alternate"
            hrefLang="ru-uz" />
      <link href="https://kg.chesnok.bet"
            rel="alternate"
            hrefLang="ru-kg" />
      <link href="https://kz.chesnok.bet"
            rel="alternate"
            hrefLang="ru-kz" />

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: `
          {
            "@context": "http://schema.org/",
            "@type": "WebSite",
            "url": "https://${currentRegion}.chesnok.bet/",
            "potentialAction": {
            "@type": "SearchAction",
            "target": "https://${currentRegion}.chesnok.bet/?search={search_term_string}",
            "query-input": "required name=search_term_string"
            }
            }
          
          `,
        }} />
    </Helmet>
  );
};
